module.exports = __webpack_public_path__ + "static/img/zhizhudisc.5c673b1e.jpg";